import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'styles/util';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const AttentionPolygon = ({ text }) => {
    const polygonRef = useRef();
    const [polygonClipPath, setPolygonClipPath] = useState(71.625);

    const useStyles = makeStyles(({ theme, fonts, colors }) => ({
        wrapper: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            backgroundColor: colors.attentionBackground,
            clipPath: `polygon( 71.625% 0%, 0% 22.829%, 0% 100%, 100% 100%, ${polygonClipPath}% 0% )`
        },
        text: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            padding: theme.spacing(2.25, 6.25, 1.25, 2),
            color: colors.attentionForeground,
            fontFamily: fonts.bold
        },
    }));
    const classes = useStyles();

    useEffect(() => {
        // Standard is 71.625% based on a width of the polygon at 14 characters
        if (polygonRef.current) {
            const value = Math.round(((polygonRef.current.textContent.length - 14) / 1.5 + 71.625) * 1000) / 1000;
            setPolygonClipPath(value);
        }
    }, []);

    if(!text) {
        return null;
    }

    return (
        <Box className={classes.wrapper}>
            <Typography ref={polygonRef} variant="body2" className={classes.text}>{text}</Typography>
        </Box>
    );
};

AttentionPolygon.propTypes = {
    text: PropTypes.string
};

export default AttentionPolygon;
